/**
 * App Header
 */
import {withStyles} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import MenuIcon from '@material-ui/icons/Menu';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {compose} from 'redux';
import screenfull from 'screenfull';
import {collapsedSidebarAction, miniSidebarAction} from '../../actions';
import LanguageProvider from './LanguageProvider';
import Notifications from './Notifications';
import RecognizedPagesCounter from './RecognizedPagesCounter';
import MoveToPlanButton from "Components/Button/MoveToPlanButton";

const Header = ({classes, settings, miniSidebarAction}) => {
    const {t: translate} = useTranslation();

    const onToggleSidebarCollapsed = () => {
        const val = !settings.miniSidebar;
        if (val) {
            document.body.classList.add('mini-sidebar');
        } else {
            document.body.classList.remove('mini-sidebar');
        }
        miniSidebarAction(val);
    };

    const toggleScreenFull = () => {
        screenfull.toggle();
    };

    return (
        <AppBar position="static" className="rct-header">
            <Toolbar className="d-flex justify-content-between w-100 pl-0">
                <div className="d-flex align-items-center">
                    <ul className="list-inline mb-0 navbar-left">
                        <li className="list-inline-item">
                            <Tooltip title="Sidebar Toggle" placement="bottom">
                                <IconButton
                                    color="inherit"
                                    className="humburger"
                                    mini="true"
                                    aria-label="Menu"
                                    onClick={() => onToggleSidebarCollapsed()}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </Tooltip>
                        </li>
                    </ul>
                </div>
                <ul className={`navbar-right list-inline mb-0 ${classes.rightNavbar}`}>
                    <li className='list-inline-item'>
                        <RecognizedPagesCounter />
                    </li>
                    <li className="list-inline-item">
                        <Tooltip title={`${translate('common.actions.upgrade_plan')}`} placement="bottom">
                            <span>
                                <MoveToPlanButton label='widgets.upgrade' />
                            </span>
                        </Tooltip>
                    </li>
                    <LanguageProvider />
                    <Notifications />
                    <li className="list-inline-item">
                        <Tooltip title="Full Screen" placement="bottom">
                            <IconButton
                                aria-label="settings"
                                onClick={toggleScreenFull}
                            >
                                <i className="zmdi zmdi-crop-free" />
                            </IconButton>
                        </Tooltip>
                    </li>
                </ul>
            </Toolbar>
        </AppBar>
    );
};

// map state to props
const mapStateToProps = (state) => ({settings: state.settings});

export default compose(
    connect(mapStateToProps, {
        collapsedSidebarAction,
        miniSidebarAction,
    }),
    withStyles({
        rightNavbar: {
            display: 'flex',
            alignItems: 'center',
        },
    }),
)(Header);
